import PropTypes from 'prop-types'
import Select from '@mui/material/Select'
import './SelectWithLabel.css'

const SelectWithLabel = ({ children, className, label, name, onChange, value }) => {
    const classNames = `select-with-label ${className ?? ''}`

    return (
        <div className={classNames}>
            <div className='label'>{label}</div>
            <Select
                className='select'
                name={name}
                onChange={onChange}
                value={value}
                variant='standard'
            >
                {children}
            </Select>
        </div>
    )
}

SelectWithLabel.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
}

export default SelectWithLabel
